<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-29 16:29:02
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
         
 <div class="pageTitle">盘点统计</div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="经销商盘点统计" name="1">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
      
         <el-form-item label="经销商:" style='margin-right:50px;'>
             <el-col :span='20' style='margin-right:20px;'>
        <el-input v-model="form.to_sn" clearable></el-input>

             </el-col>
                    <el-col :span='2'>
              <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>

             </el-col>

      </el-form-item>
     <el-form-item label="经销商级别:">
            <el-select v-model="form.to_level_id" placeholder="请选择经销商级别" clearable>
              <el-option v-for=" (i,k) in dealerLevel" :key="k" :label="i.level_name" :value="i.id"></el-option>
            </el-select>
          </el-form-item>
      <!--  -->
  
 <!--  -->
      <el-form-item>
        <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="loading"
      border
      stripe
      style="width: 100%;margin: 20px"
    >
      <el-table-column prop='to_sn' label="序号" fixed>
        <template slot-scope="scope"> 
          {{scope.$index}}
        </template>
      </el-table-column>
      <el-table-column prop='to_sn' label="经销商编号" fixed></el-table-column>
      <el-table-column prop='to_name' label="经销商名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop='to_level_name' label="经销商级别" show-overflow-tooltip></el-table-column>
           <el-table-column
                        prop=""
                        label="操作"
                        width="180"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="checkdetail(scope.row)">查看明细</el-button>

                    </template>
                </el-table-column>
    </el-table>
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    ></el-pagination>
    </el-tab-pane>
    <el-tab-pane label="门店盘点统计" name="2">

        <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
  
         <el-form-item label="门店:">
             <el-col :span='20' style='margin-right:20px;'>
        <el-input v-model="form1.to_sn" clearable></el-input>
             </el-col>
                    <el-col :span='2'>
        <el-button @click="selectStoreDialog=!selectStoreDialog">选择</el-button>
             </el-col>

      </el-form-item>
  
       <el-form-item label="门店类型:" style='margin-left:15px;'>
                <el-select v-model="form1.to_level_id" >
                <el-option label=" " value=" ">全部</el-option>
                <el-option :label="v.id" :value="v.id" v-for="(v,k) in ShopLeve" :key='k'>{{v.level_name}}</el-option>

              </el-select>
              </el-form-item>
      <!--  -->
  
 <!--  -->
      <el-form-item>
        <el-button type="primary" @click="onSearch()" class="mr-10">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData1"
      v-loading="loading"
      border
      stripe
      style="width: 100%;margin: 20px"
    >
      <el-table-column prop label="序号" fixed>
        <template slot-scope="scope">
          {{scope.$index}}
        </template>
      </el-table-column>
      <el-table-column prop='to_sn' label="门店编号" fixed></el-table-column>
      <el-table-column prop='to_name' label="门店名称" show-overflow-tooltip></el-table-column>
      <el-table-column prop='to_level_name' label="门店类型" show-overflow-tooltip></el-table-column>
        <el-table-column
                        prop=""
                        label="操作"
                        width="180"
                        show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="checkdetail(scope.row)">查看明细</el-button>
                  
                    </template>
                </el-table-column>
    </el-table>
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange1"
      @current-change="handleCurrentChange1"
      :current-page="pageNo1"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize1"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize1"
    ></el-pagination>
    </el-tab-pane>
    
  </el-tabs>
    

    <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
   
    <selectStore
      v-if="selectStoreDialog"
      v-on:handleClose="selectStoreDialog = false"
      @pushData="getSelectStore"
    ></selectStore>
    <el-dialog
  title="查看明细"
  :visible.sync="detailDialog"
  width="80%"
  >
  <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
                     <el-form-item label="盘点时间" style="text-align: center">
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="开始时间" v-model="form2.start_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                    <el-date-picker type="date" placeholder="结束时间" v-model="form2.end_time"
                                    style="width: 100%;"></el-date-picker>
                </el-col>
            </el-form-item>
              <el-form-item  label="关键词:">
                        <el-input v-model="form2.keyword" clearable ></el-input>
                    </el-form-item>
                 <el-form-item >
        <el-button type="primary" @click="onSearchDetail()" class="mr-10">搜索</el-button>
                 <el-button type="primary"  @click="exportData">导出明细</el-button>

            </el-form-item>

  </el-form>

    <el-table
              ref="multipleTable"
              :data="tableData2"
              v-loading="loading"
              border
              stripe
            >
              <!-- <el-table-column prop label="序号" fixed >
                   <template slot-scope="scope">
                 {{scope.$index}}
                </template>
              </el-table-column> -->
            
              <el-table-column prop='inventory_sn' label="盘点单号" fixed></el-table-column>             
                            
                            
              <el-table-column prop='production_batch'  label="盘点时间" fixed width="200" >
                <template slot-scope="scope">
                  {{scope.row.created_at}}至{{scope.row.updated_at}}
                </template>
              </el-table-column>
            <el-table-column prop='total_num' label="原库存总数" ></el-table-column>
              <el-table-column prop='inventory_missing_num' label="盘点缺失数量" ></el-table-column>
              <el-table-column prop='inventory_after_num' label="盘点后库存总数" ></el-table-column>
              <el-table-column prop='allotment_name' label="盘点人" >
                  <template slot-scope="scope">
                  {{scope.row.allotment_name}}({{scope.row.allotment_sn}})
                </template>
              </el-table-column>
              <el-table-column prop='remarks' label="备注" ></el-table-column>
                <el-table-column prop='production_batch' label="操作"  fixed="right" >
                <template slot-scope="scope">
                  <el-button type='text' @click='getLost(scope.row)'>查看详情</el-button>                  
                </template>
              </el-table-column>
            </el-table>
              <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange5"
              @current-change="handleCurrentChange5"
              :current-page="pageNo5"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize5"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize5"
            ></el-pagination>
  <span slot="footer" class="dialog-footer">
    <el-button @click="detailDialog = false,pageSize5=10,pageNo5=1">取 消</el-button>
    <el-button type="primary" @click="detailDialog = false,pageSize5=10,pageNo5=1">确 定</el-button>
  </span>
</el-dialog>
        <el-dialog
      title="缺失明细"
      :visible.sync="lostDetailDialog"
      width="80%"
      >
      <el-table
              ref="multipleTable"
              :data="tableData3"
              v-loading="loading"
              border
              stripe
            >
              <el-table-column prop='logistics_code' label="物流码"  >
                
              </el-table-column>
            
              <el-table-column prop='code_type' label="标签类型" fixed></el-table-column>             
                            
                            
              <el-table-column prop='product_sn'  label="产品编号" fixed width="200" >
              
              </el-table-column>
            <el-table-column prop='product_name' label="产品名称" ></el-table-column>
              <el-table-column prop='product_specs' label="产品规格" ></el-table-column>
              <el-table-column prop='real_stock_out_num' label="缺失数量" ></el-table-column>
            </el-table>
         <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange6"
              @current-change="handleCurrentChange6"
              :current-page="pageNo5"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize6"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize6"
            ></el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lostDetailDialog = false,pageSize5=10,pageNo5=1">取 消</el-button>
        <el-button type="primary" @click="lostDetailDialog = false,pageSize5=10,pageNo5=1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import selectDealer from "@/components/logistics/common/selectDealer.vue";
import selectStore from "@/components/logistics/common/selectStore.vue";

export default {
  name: "deliver-manage",
  data() {
    return {
        activeName:"1",
      loading: false,
      detailDialog:false,
      selectDealerDialog: false,
      selectStoreDialog: false,
      lostDetailDialog:false,
      sn:'',
      form: {},
      form1:{},
      form2:{},
      dealerLevel: [], 
      tableData: [],
      tableData1:[],
      tableData2:[],
      tableData3:[],
      tempData:[],
      ShopLeve:[],
      //分页
      pageNo: 1,
      pageSize: 20,
      totalSize: 0,

        pageNo1: 1,
      pageSize1: 20,
      totalSize1: 0,
       pageNo5: 1,
      pageSize5: 10,
      totalSize5: 0,

        pageNo6: 1,
      pageSize6: 10,
      totalSize6: 0,
      stock_out_sn: "", //传给物流明细
      showLink: false //'登陆地址弹窗'
      ,inventory_sn:''
    };
  },
  methods: {
    //获取经销商级别
    getDealerLevel() {
      this.$get("logistics", "/dealers.level", {})
        .then(res => {
          //console.log(res);
          this.dealerLevel = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
        //获取门店级别清单
    ShopLeves() {
      this.$get("logistics", "/shops.level", {
        lang: ""
      })
        .then(res => {
          this.ShopLeve = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 搜索明细列表
    onSearchDetail(){
      console.log(this.form2)
      var form=this.form2
           let beginstr = "",
        endstr = "";
      if (form.start_time) {
        beginstr = this.moment(form.start_time).format("YYYY-MM-DD");
      }
      if (form.end_time) {
        endstr = this.moment(form.end_time).format("YYYY-MM-DD");
      }
    
     this.tableData2 = this.tempData.filter(data=>{
        //日期假设date,人名 name
return data.created_at.toLowerCase().includes(beginstr.toLowerCase())&&data.updated_at.toLowerCase().includes(endstr.toLowerCase())&&JSON.stringify(data).indexOf(form.keyword) != -1 ;
    });
    },
    //获取选择经销商门店
    getSelectinfo(val) {
        this.form.to_sn = val.dealer_sn;
        this.form.to_type = 2;

    },
     //获取选择门店
    getSelectStore(val) {
        this.form1.to_sn = val.shop_sn;
        this.form1.to_type = 3;
    },
    // 查看明细
    checkdetail(data){
      this.detailDialog=true
      this.loading=true
      this.sn=data.to_sn
      if(this.activeName==1){
        this.$get('logistics','/inventories.dealers/'+data.to_sn,{
 page:this.pageNo5,
        per_page:this.pageSize5,
        }).then(res=>{
          this.tableData2=res.data
          this.tempData=res.data
         this.loading=false
          this.totalSize5 = res.meta.total;

        })
      }else{
         this.$get('logistics','/inventories.shops/'+data.to_sn,{
            page:this.pageNo5,
        per_page:this.pageSize5,
         }).then(res=>{
          this.tableData2=res.data
          this.tempData=res.data

      this.loading=false
          this.totalSize5 = res.meta.total;


        })
      }
    },
    getLost(data){
      this.lostDetailDialog=true
      this.inventory_sn=data.inventory_sn
// inventory_sn
       this.loading=true
    
      this.$get('logistics','/inventories.details/'+data.inventory_sn,{
      page:this.pageNo6,
      per_page:this.pageSize6,
      }).then(res=>{
        this.tableData3=res.data
     this.loading=false
          this.totalSize5 = res.meta.total;

      }).catch(error=>{
        this.$message({
          type:'error',
          message:error.message
        })
        setTimeout(() => {
      this.lostDetailDialog=false
          
        }, 1000);
      })
    },
    //请求列表数据
    onSearch() {
    
      this.loading = true;
      if(this.activeName=='1'){
          this.tableData=[]
          this.$get("logistics", "/inventories.dealers", {
        lang: "",
        page:this.pageNo,
        per_page:this.pageSize,
       ...this.form
      })
        .then(res => {
          this.loading = false;
          this.tableData = res.data;
          this.totalSize = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
        });
      }else{
              this.$get("logistics", "/inventories.shops", {
        lang: "",
        page:this.pageNo1,
        per_page:this.pageSize1,
       ...this.form1
      })
        .then(res => {
          this.loading = false;
          this.tableData1 = res.data;
          this.totalSize1 = res.meta.total;
        })
        .catch(function(error) {
          this.loading = false;
          console.log(error);
        });
      }
    
    },
    handleClick(){
    this.onSearch();
    },
    //选择经销商/门店
    selectType() {
      this.selectDealerDialog = true;
    },
    //导出
    exportData() {
      let url = "",
        access_tokens = localStorage.getItem("access_tokens");
 
      if(this.activeName==1){
window.open(
       this.$Base_Export +
          "/inventories.dealers.export/"+this.sn+"?"+   
          "&lang=" +
          '&is_export=1'+
          "" +
          "&signature=" +
          this.$md5(access_tokens)
      );
      }else{
window.open(
        this.$Base_Export +
          "/inventories.shops.export/"+this.sn+"?"+   
          "&lang=" +
          '&is_export=1'+
          "" +
          "&signature=" +
          this.$md5(access_tokens)
      );
      }
  
    },

    /*分页*/
    handleSizeChange1(val) {
      this.pageSize1= val;
      this.pageNo1 = 1;
      this.onSearch();
    },
    handleCurrentChange1(val) {
      this.pageNo1 = val;
      this.onSearch();
    },
     /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    /*分页*/
    handleSizeChange5(val) {
      this.pageSize5 = val;
      this.pageNo5 = 1;
      this.checkdetail();
    },
    handleCurrentChange5(val) {
      this.pageNo5 = val;
      this.onSearch();
    },

      handleSizeChange6(val) {
      this.pageSize6 = val;
      this.pageNo6 = 1;
      this.getLost({inventory_sn:this.inventory_sn});
    },
    handleCurrentChange6(val) {
      this.pageNo6 = val;
      this.getLost({inventory_sn:this.inventory_sn});

    },
  },
  created() {
    this.ShopLeves()
    this.getDealerLevel();
      this.onSearch();

    // this.checkdetail();
  },
  components: {
    // , importData, deliverCodeDialog
    selectDealer,selectStore
  }
};
</script>
<style lang="scss" scoped>
.container .pageTitle{
    height: auto;
    margin-bottom: 10px;
}
/deep/.el-table .cell{
// height: 30px;
} 
</style>